import Component from '../core/Component'
import $ from 'jquery'
import { loadComponents } from '../core/componentUtils';

export default class ScrollTo extends Component {
    constructor(element) {
        super(element)
        this.$element = $(this.element)
    }

    prepare() {
        this.$element.on('click', event => {
            event.preventDefault()
            var link = document.createElement('a')
            link.href = this.$element.attr('href')
            this.target = document.querySelector(link.hash)
            this.scrollTo(window, this.offset(this.target).top, 480)
        })
    }

    scrollTo(element, to, duration) {
        var start = $(element).scrollTop(),
            change = to - start,
            increment = 20

        var animateScroll = (elapsedTime) => {
            elapsedTime += increment
            var position = easeInOut(elapsedTime, start, change, duration)
            $(element).scrollTop(position)
            if (elapsedTime < duration) {
                setTimeout(() => {
                    animateScroll(elapsedTime)
                }, increment)
            } else {
                console.log('scroll done')
            }
        };

        animateScroll(0);

        function easeInOut(currentTime, start, change, duration) {
            currentTime /= duration / 2;
            if (currentTime < 1) {
                return change / 2 * currentTime * currentTime + start;
            }
            currentTime -= 1;
            return -change / 2 * (currentTime * (currentTime - 2) - 1) + start;
        }
    }

    offset(el) {
        var rect = el.getBoundingClientRect(),
            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
    }
}